import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./Careers.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
export default class Careers extends Component {
  render() {
    return (
      <div className="mt-9">
        <Container>
          <div className="text-center">
            <p className="hero-text-2 hero-text-gradient-2">
              Where Passion Meets Purpose
            </p>
            <p>
              We're looking for passionate individuals who dare to think
              differently and are ready to make their mark in technology,
              marketing, and digital revolution.
            </p>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-2 text-center">
              <img src="./assets/icons/world-creativity-and-innovation-day-1.gif" className="w-50" alt="" />
              <p>Innovate</p>
            </div>
            <div className="col-2 text-center">
              <img src="./assets/icons/digital-collaboration.gif" className="w-50" alt="" />
              <p>Collaborate</p>
            </div>
            <div className="col-2 text-center">
              <img src="./assets/icons/growth.gif" className="w-50" alt="" />
              <p>Grow</p>
            </div>
          </div>
          <div className="text-center mt-4">
            <button className="primary-btn fw-500">View Openings</button>
          </div>
          <div className="row mt-5 mx-4">
            <div className="col-6 border border-start-0 p-2">
              <p>
                “What I love about Ambrum is the balance cutting edge tech meets
                a deeply collaborative culture. We don’t just code solutions, we
                build products that matter. Ambrum is a place where voices are
                heard. Whether you’re an intern or a team lead, your input
                shapes the outcome. It’s not just work, it’s ownership.”
              </p>
              <img src="./assets/people/tech-lead.png" alt="" />
              <div className="row">
                <div className="col">
                  <p>Tharindu Mihiran - Tech Lead</p>
                </div>
                <div className="col text-end">Next{">"}</div>
              </div>
            </div>
            <div className="col-6 border border-end-0  border-start-0 p-2">
              <img
                src="./assets/images/slider/slider1.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="my-5 text-center">
              <div className="hero-text-2">Interview Process</div>
              <p>
                We have built a simple and consistent 4 step process to evaluate
                whether Ambrum is the right fit for you and vise versa. All you
                have to do to ace an interview here at Ambrum is to bring your
                best self to the interview!
              </p>
              <div className="row col-11 m-auto">
                <div className="col-2 m-auto">Phone Screening</div>
                <div className="col-1 flex">
                  <img
                    src="./assets/icons/right-arrow.gif"
                    className="w-100 m-auto"
                    alt=""
                  />
                </div>
                <div className="col-2 m-auto">First Interview</div>
                <div className="col-1 flex">
                  <img
                    src="./assets/icons/right-arrow.gif"
                    className="w-100 m-auto"
                    alt=""
                  />
                </div>
                <div className="col-2 m-auto">Assessment</div>
                <div className="col-1 flex">
                  <img
                    src="./assets/icons/right-arrow.gif"
                    className="w-100 m-auto"
                    alt=""
                  />
                </div>
                <div className="col-2 m-auto">Final Interview</div>
              </div>
            </div>
            <hr />
            <div className="my-5 text-center">
              <div className="hero-text-2">Careers at Ambrum</div>
              <div className="search-input-wrapper">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search"
                />
                <i className="fas fa-search search-icon"></i>
              </div>
              <div className="row mt-5 col-10 bg-light m-auto rounded-pill p-2">
                <div className="col-10 text-start">
                  Digital Marketing Executive
                </div>
                <div className="col-2 secondary-text-color">
                  Apply Now {">"}
                </div>
              </div>
            </div>
            {/* <div className="container text-center">
              <div className="hero-text fw-700 my-5">
                LET’S{" "}
                <span className="hero-text-gradient">TRANSFORM THE FUTURE</span>{" "}
                <br />
                TOGETHER
              </div>
              <p>Book a free consultation{">"}</p>
            </div> */}
             <ContactUsFooter/>
          </div>
        </Container>
        <br />
        <Footer/>
      </div>
    );
  }
}
